import { createSelector } from '@ngrx/store';
import {
  ActionTypes,
  TypeAction,
  FetchingPropsEnum,
  FetchingStatusEnum
} from './agreement-resign.actions';
import { IRootState } from '../../store';

export { FetchingPropsEnum, FetchingStatusEnum };

export interface IFetchingState {
  agreement: FetchingStatusEnum;
  terms: FetchingStatusEnum;
}

export interface ISignatureFormData {
  signature: string;
}

export interface State {
  publicKey: string;
  isSigned: boolean;
  isResignNeeded: boolean;
  terms: string;
  formData: ISignatureFormData;
  fetching: IFetchingState;
}

const initialState: State = {
  publicKey: '',
  isSigned: false,
  isResignNeeded: false,
  terms: '',
  formData: {
    signature: ''
  },
  fetching: {
    agreement: FetchingStatusEnum.initial,
    terms: FetchingStatusEnum.initial,
  }
};

export function agreementResignReducer(state: State = initialState, action: TypeAction): State {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.STORE_AGREEMENT_RESIGN_DETAILS: {
      return Object.assign({}, state, payload);
    }

    case ActionTypes.SAVE_AGREEMENT_RESIGN_TERMS: {
      return Object.assign({}, state, { terms: payload });
    }

    case ActionTypes.UPDATE_SIGNATURE_FORM_DATA: {
      const formData = Object.assign({}, state.formData, {
        [payload.fieldId]: payload.value
      });
      return Object.assign({}, state, { formData });
    }

    case ActionTypes.FETCHING_END: {
      return Object.assign({}, state, {
        fetching: {
          ...state.fetching,
          [FetchingPropsEnum[payload.field]]: payload.status
        }
      });
    }

    default: {
      return state;
    }
  }
}

export const getAgreementResignDetails = createSelector(
  ({ agreementResign }: IRootState) => agreementResign,
  (state: State) => ({
    publicKey: state.publicKey,
    isSigned: state.isSigned,
    isResignNeeded: state.isResignNeeded
  })
);

export const getAgreementResignTerms = createSelector(
  ({ agreementResign }: IRootState) => agreementResign,
  (state: State) => state.terms
);

export const getSignatureFormData = createSelector(
  ({ agreementResign }: IRootState) => agreementResign,
  (state: State) => state.formData
);

export const getAgreementResignSubmitData = createSelector(
  ({ agreementResign }: IRootState) => agreementResign,
  (state: State) => ({
    publicKey: state.publicKey,
    signature: state.formData.signature
  })
);

export const getPropFetchingStatus = (prop: FetchingPropsEnum) => createSelector(
  ({ agreementResign }: IRootState) => agreementResign,
  ({ fetching }: State): FetchingStatusEnum => fetching[FetchingPropsEnum[prop]]
);
